import ReactDOM from 'react-dom';

const FixedTooltipPortal = ({ content, visible, position, tooltipComponent: TooltipComponent }) => {
  if (typeof document === 'undefined' || !content || !TooltipComponent) return null;

  return ReactDOM.createPortal(
    <TooltipComponent
      role="tooltip"
      $visible={visible}
      style={{ top: position.top, left: position.left }}
    >
      {content}
    </TooltipComponent>,
    document.body,
  );
};

export default FixedTooltipPortal;
